import React from 'react';

interface OrderConfirmationCardProps {
  orderId: string;
  paper: string;
  printer: string;
  dimensions: string;
}

const OrderConfirmationCard: React.FC<OrderConfirmationCardProps> = ({ orderId, paper, printer, dimensions }) => {
  return (
    <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg w-full max-w-md mx-auto border border-green-500">
      <div className="text-center mb-4">
        <svg className="w-16 h-16 mx-auto text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white mt-2">Order Confirmed!</h2>
        <p className="text-gray-600 dark:text-gray-400">Thank you for your purchase.</p>
      </div>
      <div className="space-y-4">
        <div className="p-4 bg-gray-100 dark:bg-gray-700 rounded-lg">
          <p className="text-sm font-medium text-gray-500 dark:text-gray-400">Order ID</p>
          <p className="text-lg font-semibold text-gray-900 dark:text-white">{orderId}</p>
        </div>
        <div>
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">Order Summary</h3>
          <ul className="space-y-2 text-gray-700 dark:text-gray-300">
            <li className="flex justify-between"><span>Paper:</span> <strong>{paper}</strong></li>
            <li className="flex justify-between"><span>Printer:</span> <strong>{printer}</strong></li>
            <li className="flex justify-between"><span>Dimensions:</span> <strong>{dimensions}</strong></li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmationCard;
